/* eslint-disable */
export const user = {
    _id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name: 'Brian Hughes',
    email: 'hughes.brian@company.com',
    role: 'admin' as const,
    isEmailVerified: true,
    picture: 'images/avatars/brian-hughes.jpg',
    locale: 'en',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
};
